exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".node text{font:10px sans-serif;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/styles/nodes.scss
// module id = 12
// module chunks = 0